import React from 'react'
import runningMakkara from '../../assets/video/running.mp4'
import ProgressBar from './ProgressBar'


/**
* @author zilahir
* @function Success
**/

const Success = () => {
	return (
		<div className="video-container">
			<div className="message-bubble">
				<p>
					Hello! I am makkaraman, I am delivering your message. Thank you!
				</p>
			</div>
			<video
				autoPlay
				className="running-makkara"
				loop
			>
				<source src={runningMakkara} type="video/mp4" />
			</video>
			<ProgressBar />
		</div>
	)
}

export default Success